import { render, staticRenderFns } from "./pygame-template.vue?vue&type=template&id=56519b9c&scoped=true"
import script from "./pygame-template.vue?vue&type=script&lang=js"
export * from "./pygame-template.vue?vue&type=script&lang=js"
import style0 from "./pygame-template.vue?vue&type=style&index=0&id=56519b9c&scoped=true&lang=scss"
import style1 from "./pygame-template.vue?vue&type=style&index=1&id=56519b9c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56519b9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56519b9c')) {
      api.createRecord('56519b9c', component.options)
    } else {
      api.reload('56519b9c', component.options)
    }
    module.hot.accept("./pygame-template.vue?vue&type=template&id=56519b9c&scoped=true", function () {
      api.rerender('56519b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/pygame-template.vue"
export default component.exports